module.exports = __webpack_public_path__ + "static/media/Logo_reveillon_Preta.75e64c9f.svg";